import React from 'react';
import { useParams } from 'react-router-dom';
import LiveMonitoring from 'pages/LiveMonitoring';

export const RespondentMonitoringPage: React.FC = () => {
    const { testId } = useParams<{ testId: string }>();
    return <LiveMonitoring defaultTestId={testId} />;
};

export default RespondentMonitoringPage;
